
import React, {useEffect, useState} from "react";
import SinglePageLayout from "../../layouts/singlePageLayout/singlePageLayout";

import { showLoading, hideLoading } from 'react-redux-loading-bar';
import {useNavigate } from "react-router-dom";
import {connect} from 'react-redux';


import logo from './../../assets/images/cklogo.png';
import lilJon from './../../assets/images/lil-jon.jpeg';
import membershipLogo from './../../assets/images/FunnelPage-2025.jpeg';

const Funnel = ({ displayLoading, hideLoading }) => {
    const navigate = useNavigate();

    const sendToPaymentMethodPage = () => {
        navigate('/sign-in?redir=subscription/payment-method/31');
    }


    return (
        <SinglePageLayout>
            <div className="funnel-container">
                <div className="max-w-3xl mx-auto px-4 py-10 text-center">
                    <div className="top-logo">
                        <img src={logo} alt="Clubkillers sign in" title="Clubkiller sing in" style={{maxWidth: '100px' }} />
                    </div>
                    <h1 className="text-4xl font-bold text-green-400 mb-2">🔥 DJS, GET UNLIMITED CRATES FOR $7.99/MO</h1>
                    <div className="middel-logo">
                        <img src={membershipLogo} alt="Membership" title="Membership" style={{maxWidth: '70%' }} />
                    </div>
                    <p className="text-4xl font-bold text-green-400 mb-6">72 HOURS ONLY — CURATED EDITS,<br /> REMIXES & CRATES BY INDUSTRY LEADERS</p>
                    <div className="middel-video">
                        <iframe width="718" height="404" src="https://www.youtube.com/embed/jxqEuL3QggQ" title="2024 ClubKillers Record Pool Review | Where DJs Get Their Music!" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                    </div>
                    <div className="bg-gray-900 p-6 rounded-lg mb-6">
                        <h2 className="text-xl font-semibold mb-4">What You Get</h2>
                        <ul className="space-y-2 text-left max-w-md mx-auto">
                            <li>✅ Unlimited edits, remixes, & playlists</li>
                            <li>✅ Curated drops from top DJs</li>
                            <li>✅ One-click downloads + rescue tools</li>
                            <li>✅ Keep lifetime pricing after 3 months</li>
                        </ul>
                    </div>
                
                    <div className="bg-pink-600 text-white p-4 rounded-lg mb-9">
                        <h3 className="text-2xl font-bold">$7.99/mo for your first 3 months</h3>
                        <p>Then just $30/month — locked in for life</p>
                        <p>No contracts. Cancel anytime.</p>
                    </div>
                
                    <button onClick={() => sendToPaymentMethodPage()} className="bg-pink mx-w-200 mx-auto text-white text-lg font-bold px-6 py-3 rounded-full shadow-lg hover:bg-pink-500 hover:text-white transition">Unlock This Deal</button>
                
                    <div className="mt-5">
                        <p className="text-sm italic text-gray-400 testimonial m-0"><span>"Club Killers Has The Most Useful Mash Ups And Remixes For My Sets." — Lil Jon</span> <span>      <img src={lilJon} alt="Lil Jon" title="Lil Jon" style={{width: '50px', borderRadius: '50%' }} /></span></p>
                        <p className="text-sm italic text-green-400 m-0">Trusted by 20,000+ DJs worldwide</p>
                    </div>
    
                    <br /> <br /><br />
                </div>
            </div>
        </SinglePageLayout>
    );
}
function mapStateToProps(state) {
  return {
	
  };
}

function mapDispatchToProps(dispatch) {
  	return {
      	displayLoading: (sectionBar) => dispatch(showLoading(sectionBar)),
        hideLoading: (sectionBar) => dispatch(hideLoading(sectionBar)),
        
  	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Funnel);